module.exports = __webpack_public_path__ + "img/my_user_black.35168275.png";